import {ToastEngine, ToastConfig} from "@shared/libs/toast";
import { Toast } from 'vant';
import {ToastOptions} from "vant/es/toast";

class ToastEngineVant implements ToastEngine {
    info(config: ToastConfig): void {
        Toast(this.convertConfig(config));
    }

    success(config: ToastConfig): void {
        Toast.success(this.convertConfig(config));
    }

    warn(config: ToastConfig): void {
        Toast(this.convertConfig(config));
    }

    error(config: ToastConfig): void {
        Toast.fail(this.convertConfig(config));
    }

    private convertConfig(config: ToastConfig): ToastOptions {
        const cfg =  {
            message: config.text,
            duration: config.duration,
        } as ToastOptions;

        if (cfg.duration) {
            cfg.duration = cfg.duration * 1000;
        }

        return cfg;
    }
}

export default ToastEngineVant;
